import React from "react";

const Skills = () => {

    return (<>
        <div id="ski" className="Skills1">
            <h1 id="ski1">Skills</h1>
            <div className="Skills2" >
                <div id="html" className="card" data-aos="fade-up">
                    <h1>HTML</h1>
                    <img src="html.png" />
                </div>
                <div id="css" className="card" data-aos="fade-up">
                    <h1>CSS</h1>
                    <img src="css.png" />
                </div>
                <div id="javascript" className="card" data-aos="fade-up">
                    <h1>Javascript</h1>
                    <img src="javascript.png" />
                </div>
                <div id="react" className="card" data-aos="fade-up">
                    <h1>Reactjs</h1>
                    <img src="react.png" />
                </div>
                <div id="mysql" className="card" data-aos="fade-up">
                    <h1>Mysql</h1>
                    <img src="mysql.png" />
                </div>
                <div id="python" className="card" data-aos="fade-up">
                    <h1>Python</h1>
                    <img src="python.png" />
                </div>
                <div id="java" className="card" data-aos="fade-up">
                    <h1>Java</h1>
                    <img src="java1.png" />
                </div>
                <div id="git" className="card" data-aos="fade-up">
                    <h1>Git</h1>
                    <img src="git1.png" />
                </div>
                <div id="github" className="card" data-aos="fade-up">
                    <h1>Github</h1>
                    <img src="github1.png" />
                </div>
            </div>
        </div>
    </>)
}
export default Skills